// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anonymousLayout {
  color: #061c3f;
  padding-bottom: 52px;
  text-align: center;
}
.anonymousLayout .content {
  padding: calc(40px / 2) 40px 40px 40px;
}
.anonymousLayout .content h1 {
  margin: 10px 0;
}
@media (max-width: 599px) {
  .anonymousLayout .globalFooter {
    display: block;
    height: 85px;
    bottom: 50px;
  }
  .anonymousLayout .content {
    padding: 2%;
  }
}
@media (max-width: 1200px) {
  .anonymousLayout .anonymousHeader {
    margin-bottom: 12px;
  }
  .anonymousLayout .content h1 {
    margin-top: 0;
    margin-bottom: 10px;
  }
}
@media (max-height: 713px) {
  .anonymousLayout .globalFooter {
    position: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/layouts/AnonymousLayout.less"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,oBAAA;EACA,kBAAA;AADD;AAFA;EAME,sCAAA;AADF;AALA;EASG,cAAA;AADH;AAMA;EACC;IAEE,cAAA;IACA,YAAA;IACA,YAAA;EALD;EACD;IAQE,WAAA;EAND;AACF;AAUA;EACC;IACC,mBAAA;EARA;EAWD;IACC,aAAA;IACA,mBAAA;EATA;AACF;AAYA;EACC;IAEE,eAAA;EAXD;AACF","sourcesContent":["@import (reference) '../constants.less';\n\n.anonymousLayout {\n\tcolor: @nightBlue;\n\tpadding-bottom: @globalFooterHeight;\n\ttext-align: center;\n\n\t.content {\n\t\tpadding: calc(@layoutPadding / 2) @layoutPadding @layoutPadding @layoutPadding;\n\n\t\th1 {\n\t\t\tmargin: 10px 0;\n\t\t}\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.anonymousLayout {\n\t\t.globalFooter {\n\t\t\tdisplay: block;\n\t\t\theight: 85px;\n\t\t\tbottom: 50px;\n\t\t}\n\n\t\t.content {\n\t\t\tpadding: @mobileLayoutPadding;\n\t\t}\n\t}\n}\n\n@media (max-width: @desktopMinWidth) {\n\t.anonymousLayout .anonymousHeader {\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.anonymousLayout .content h1 {\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n@media (max-height: 713px) {\n\t.anonymousLayout {\n\t\t.globalFooter {\n\t\t\tposition: unset;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
